import { createAction } from "@reduxjs/toolkit";

export const getMonitorClients = createAction("getClients");
export const getClientTons = createAction<string>("getClientTons");
export const getResultReport = createAction<{ userId: string, instrument: string}>("getResultReport");
